<template>
  <div class="mb-3">
    <custom-callout
      border-color="secondary-2"
      :controlled="true"
      has-toggle
      :opened="opened"
      @click:open="handleClosePanel"
    >
      <div class="row mt-3">
        <div class="col-md-2 col-12">
          <div class="color-secondary-6 font-14">
            Tipo de Carta:
          </div>
          <div class="font-weight-normal color-black font-16">
            {{ item?.letterType?.name | empty }}
          </div>
        </div>
        <div class="col-md-2 col-12">
          <div class="color-secondary-6 font-14">
            Fecha de Creación:
          </div>
          <div class="font-weight-normal color-black font-16">
            {{ item?.createdDate | date }}
          </div>
        </div>
        <div class="col-md-2 col-12">
          <div class="color-secondary-6 font-14">
            Fecha Última Generación:
          </div>
          <div class="font-weight-normal color-black font-16">
            {{ item?.lastGenerationDateTime | date }}
          </div>
        </div>
        <div class="col-md-2 col-12">
          <div class="color-secondary-6 font-14">
            Fecha de Última Enmienda:
          </div>
          <div class="font-weight-normal color-black font-16">
            {{ item?.lastAmendmentDateTime | date }}
          </div>
        </div>
        <div class="col-md-2 col-12">
          <div class="color-secondary-6 font-14">
            Generado Por:
          </div>
          <div class="font-weight-normal color-black font-16">
            {{ item?.generatedBy | empty }}
          </div>
        </div>
        <div
          class="col-md-2 col-12 d-flex justify-content-md-end justify-content-start"
        >
          <dropdown
            class="actions-dropdown"
            :items="actionItems"
            title=" Acciones "
          />
        </div>
      </div>
      <template #edition>
        <add-letter-doc
          v-if="actionValue == actionValues.ATTACH_SIGNED_LETTER"
          v-model="model"
          :title="letterDocPanelTitle"
          @cancel="handleClosePanel"
          @save="handleSaveSignatureDoc"
        />
        <div>
          <div
            v-if="actionValue == actionValues.ADDITIONAL_INFO"
            class="rounded p-3 mb-2 mx-0"
          >
            <letter-details :is-award="hasSignedLetter" :item="item" />
          </div>
        </div>
        <div>
          <amendment-comment
            v-if="actionValue == actionValues.AMENDMENT"
            @cancel="handleClosePanel"
            @save="amendComment"
          />
        </div>
        <amendment-history
          v-if="actionValue == actionValues.AMENDMENT_HISTORY"
          :history="amendmentHistory"
        />
      </template>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import alertMixin from '@/mixins/alert.mixin.js';
import Dropdown from 'dropdown';
import AddLetterDoc from './AddLetterDoc.vue';
import AmendmentComment from './AmendmentComment.vue';
import AmendmentHistory from './AmendmentHistory.vue';
import { serialize as objectToFormData } from 'object-to-formdata';

import {
  getDeterminationLetterAsync,
  addLetterDocument,
  getAwardLetterAsync,
  saveAmendment,
  getLetterAmendmentHistory,
} from '@/modules/proposalProcess/api.js';
import appServices from '@/modules/app/api.js';
import _generalApi from '@/modules/app/api.js';
import LetterDetails from './LetterDetails.vue';
import letterTypes from '@/modules/proposalProcess/letterTypes.js';

const ACTION_TYPES = {
  UNSET: 'UNSET',
  ADDITIONAL_INFO: 'ADDITIONAL_INFO',
  ATTACH_SIGNED_LETTER: 'ATTACH_SIGNED_LETTER',
  AMENDMENT: 'AMENDMENT',
  AMENDMENT_HISTORY: 'AMENDMENT_HISTORY',
};
export default {
  name: 'LetterRow',
  components: {
    CustomCallout,
    Dropdown,
    AddLetterDoc,
    LetterDetails,
    AmendmentComment,
    AmendmentHistory,
  },
  mixins: [alertMixin],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    model: {
      signatureFile: null,
    },
    amendmentHistory: [],
    opened: false,
    actionValues: ACTION_TYPES,
    actionValue: ACTION_TYPES.ADDITIONAL_INFO,
  }),
  computed: {
    hasSignedLetter() {
      return this.item.letterType.id == letterTypes.AWARD;
    },
    actionItems() {
      return [
        {
          label: 'Ver',
          icon: 'fas fa-eye text-green ',
          click: () => this.view(),
        },
        {
          label: 'Información Adicional',
          icon: 'fas fa-info-circle text-green',
          visible: true,
          click: () => {
            this.opened = true;
            this.actionValue = ACTION_TYPES.ADDITIONAL_INFO;
          },
        },
        {
          label: 'Imprimir Carta Determinación',
          icon: 'fas fa-print text-green ',
          visible: this.item.letterType.id == letterTypes.DETERMINED,
          click: () =>
            this.downloadDeterminationLetter(
              this.item?.announcementId,
              this.item?.id
            ),
        },
        {
          label: 'Imprimir Carta Adjudicación',
          icon: 'fas fa-print text-green ',
          visible: this.hasSignedLetter,
          click: () =>
            this.downloadAwardLetter(this.item?.announcementId, this.item?.id),
        },
        {
          label: 'Anejar Carta Firmada',
          icon: 'fas fa-file-upload text-green ',
          visible: !this.item.documentId,
          click: () => {
            this.opened = true;
            this.actionValue = ACTION_TYPES.ATTACH_SIGNED_LETTER;
          },
        },
        {
          label: 'Descargar Carta Firmada ',
          icon: 'fas fa-file-download text-green ',
          visible: Boolean(this.item.documentId),
          click: () => this.handleDownloadSignedLetter(),
        },
        {
          label: 'Enmendar',
          icon: 'fas fa-comment text-green',
          visible: this.userHasPermissions(
            'provider.competitionprocess.proposalletter.amendment'
          ),
          click: () => {
            this.opened = true;
            this.actionValue = ACTION_TYPES.AMENDMENT;
          },
        },
        {
          label: 'Historial de Enmiendas',
          icon: 'fas fa-history text-green',
          visible: true,
          click: () => {
            this.opened = true;
            this.actionValue = ACTION_TYPES.AMENDMENT_HISTORY;
            this.handleGetAmendmentHistory();
          },
        },
      ];
    },
    letterDocPanelTitle() {
      return this.item?.letterType?.id == letterTypes.AWARD
        ? 'Carta Adjudicación'
        : 'Carta Determinación';
    },
  },
  methods: {
    async downloadDeterminationLetter(announcementId, letterId) {
      const { data } = await getDeterminationLetterAsync(
        announcementId,
        letterId
      );
      appServices.downloadReportByDocumentFile(data);
      this.$emit('refresh');
    },
    async downloadAwardLetter(announcementId, letterId) {
      const { data } = await getAwardLetterAsync(announcementId, letterId);
      appServices.downloadReportByDocumentFile(data);
      this.$emit('refresh');
    },
    async handleSaveSignatureDoc() {
      try {
        const confirmation = await this.ShowCancelModal(
          'Confirmación',
          '¿Está seguro que desea anejar carta firmada?',
          'Si',
          'No'
        );

        if (!confirmation) return;

        const payload = {
          file: this.model.signatureFile,
        };
        await addLetterDocument(
          this.item.id,
          objectToFormData(payload, { indices: true, nullsAsUndefineds: true })
        );
        this.ShowToast('', 'Documento guardado correctamente', 'success');
        this.handleClosePanel();
        this.$emit('refresh');
      } catch (error) {
        const message =
          error?.response?.data?.message || 'Error al guardar el documento';
        this.ShowToast('', message, 'error');
      }
    },
    async handleDownloadSignedLetter() {
      await _generalApi.downloadDocument(this.item.documentId);
    },
    async handleGetAmendmentHistory() {
      try {
        const { data } = await getLetterAmendmentHistory(this.item.id);
        this.amendmentHistory = data;
      } catch (error) {
        this.ShowToast(
          '',
          'Error al obtener el historial de enmiendas',
          'error'
        );
      }
    },
    handleClosePanel() {
      this.handleClearModel();
      this.opened = false;
      this.actionValue = ACTION_TYPES.UNSET;
    },
    handleClearModel() {
      this.model = {
        signatureFile: null,
      };
    },
    async amendComment(comment) {
      try {
        const confirmation = await this.ShowCancelModal(
          'Confirmación',
          '¿Está seguro que desea guardar la Enmienda?',
          'Si',
          'No'
        );

        if (!confirmation) return;

        const payload = {
          letterId: this.item?.id,
          comment: comment,
        };

        await saveAmendment(payload);

        this.ShowToast('', 'Comentario guardado correctamente', 'success');
        this.handleClosePanel();
        this.$emit('viewSignature');
      } catch (error) {
        const message =
          error?.response?.data?.message || 'Error al guardar el comentario';
        this.ShowToast('', message, 'error');
      }
    },
    async view() {
      this.$emit('view');
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  label.circle-green + label {
    display: none;
  }
}
</style>
